module.exports = __webpack_public_path__ + "assets/flags/nl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/nl.svg
// module id = 509
// module chunks = 0